import { render, staticRenderFns } from "./PartnerWalletTransactionSummary.vue?vue&type=template&id=3d8c0bf9&scoped=true&"
import script from "./PartnerWalletTransactionSummary.vue?vue&type=script&lang=js&"
export * from "./PartnerWalletTransactionSummary.vue?vue&type=script&lang=js&"
import style0 from "./PartnerWalletTransactionSummary.vue?vue&type=style&index=0&id=3d8c0bf9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8c0bf9",
  null
  
)

export default component.exports